import React, { useEffect } from "react";
import "./style2.css"; // Import the CSS file
import ProgressBar from "../../ProgressBarStep";

const BusinessInfo = ({
  text,
  formData,
  setFormData,
  isEditing,
  // setIsEditing,
  errors,
  setErrors,
  handleFormFieldChange,
  userOnboardingDetails,
  userOnboardingQuestions,
  isRequireFields,
}) => {
  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Mark the specific field as being edited
    // setIsEditing((prevState) => ({
    //   ...prevState,
    //   [name]: true,
    // }));
    setFormData((prev) => ({
      ...prev,
      [name]:
        name == "companyPanNumber" || name == "gstNumber"
          ? value?.toUpperCase()
          : value,
    }));

    // Clear the specific error for the field being edited
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Handle button click for GST holder and turnover
  const handleButtonClick = (e, name, value) => {
    e.preventDefault(); // Prevent default form submission
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear the specific error for the field being edited
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // useEffect(() => {
  //   if (userOnboardingDetails) {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       ...userOnboardingDetails,
  //     }));
  //   }
  // }, [userOnboardingDetails, setFormData]);

  return (
    <div className="mainContainer">
      <h4 className="h4-business-text">{text}</h4>

      <div className="progressBar-business">
        <ProgressBar currentStep={1} />
      </div>
      <div className="formContainer-business">
        <div className="formDiv-business">
          <div className="questions">
            <div className="que">
              {/* <p>6. What is the name of your shop? *</p> */}
              <p>
                5. {userOnboardingQuestions.shopName}{" "}
                {isRequireFields?.shopName == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="inp">
              <input
                type="text"
                id="shopName"
                name="shopName"
                placeholder="Enter your shop name"
                // value={
                //   formData.shopName || userOnboardingDetails?.shopName || ""
                // }
                // value={
                //   isEditing.shopName
                //     ? formData.shopName
                //     : formData.shopName || userOnboardingDetails?.shopName || ""
                // }
                value={formData?.shopName}
                onChange={handleInputChange}
                onBlur={handleFormFieldChange}
                className={errors.shopName ? "error-input" : "input"} // Apply error class
              />
              {errors.shopName && (
                <div className="error">{errors.shopName}</div>
              )}
            </div>
          </div>

          <div className="questions">
            <div className="que">
              {/* <p>7. What is your work email address?</p> */}
              <p>
                6. {userOnboardingQuestions.officeEmailInfo}{" "}
                {isRequireFields?.officeEmailInfo == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="inp">
              <input
                type="text"
                id="workEmailAddress"
                name="workEmailAddress"
                placeholder="Enter your work email address"   
                maxLength={50}
                // value={
                //   isEditing.workEmailAddress
                //     ? formData.workEmailAddress
                //     : formData.workEmailAddress ||
                //       userOnboardingDetails?.workEmailAddress ||
                //       ""
                // }
                // value={formData?.workEmailAddress}
                value={formData?.workEmailAddress || formData?.userEmail || ""}
                onChange={handleInputChange}
                onBlur={handleFormFieldChange}
                className={errors.workEmailAddress ? "error-input" : "input"} // Apply error class
              />
              {errors.workEmailAddress && (
                <div className="error">{errors.workEmailAddress}</div>
              )}
            </div>
          </div>

          <div className="questions">
            <div className="que">
              {/* <p>8. Are you a GST holder? *</p> */}
              <p>
                7. {userOnboardingQuestions.gstCheckbox}{" "}
                {isRequireFields?.gstCheckbox == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="inp-btns">
              <button
                name="gstCheckbox"
                className={`yes-btn ${
                  formData.gstCheckbox === "Yes" ? "active" : ""
                } ${errors.gstCheckbox ? "error-button" : ""}`}
                onClick={(e) => handleButtonClick(e, "gstCheckbox", "Yes")}
                onMouseLeave={handleFormFieldChange}
              >
                Yes
              </button>
              <button
                name="isGstHolder"
                className={`no-btn ${
                  formData.gstCheckbox === "No" ? "active" : ""
                } ${errors.gstCheckbox ? "error-button" : ""}`}
                onClick={(e) => handleButtonClick(e, "gstCheckbox", "No")}
                onMouseLeave={handleFormFieldChange}
              >
                No
              </button>
              {errors.isGstHolder && (
                <div className="error">{errors.isGstHolder}</div>
              )}
            </div>
          </div>

          <div className="questions">
            <div className="que">
              {/* <p>9. Is your business turnover above ₹10 crore? *</p> */}
              <p>
                8. {userOnboardingQuestions.turnOver}{" "}
                {isRequireFields?.turnOver == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="inp-btns">
              <button
                name="turnOver"
                className={`yes-btn ${
                  formData.turnOver === "Yes" ? "active" : ""
                } ${errors.turnOver ? "error-button" : ""}`}
                onClick={(e) => handleButtonClick(e, "turnOver", "Yes")}
                onMouseLeave={handleFormFieldChange}
              >
                Yes
              </button>
              <button
                name="turnOver"
                className={`no-btn ${
                  formData.turnOver === "No" ? "active" : ""
                } ${errors.turnOver ? "error-button" : ""}`}
                onClick={(e) => handleButtonClick(e, "turnOver", "No")}
                onMouseLeave={handleFormFieldChange}
              >
                No
              </button>
              {errors.turnoverAbove10Crore && (
                <div className="error">{errors.turnoverAbove10Crore}</div>
              )}
            </div>
          </div>

          {/* <div className="questions">
            <div className="que">
              <p>10. What is your Company GSTIN? *</p>
            </div>
            <div className="inp">
              <input
                type="text"
                id="gstin"
                name="companyGstin"
                placeholder="Enter GSTIN number"
                value={formData.companyGstin}
                onChange={handleInputChange}
              />
              {errors.companyGstin && (
                <div className="error">{errors.companyGstin}</div>
              )}
            </div>
          </div> */}

          {/* Conditionally render GSTIN or Company Document Number */}
          {formData.gstCheckbox === "No" ? (
            <>
              {/* <div className="questions">
                <div className="que">
                  <p>10. {userOnboardingQuestions?.companyDocumentNumber}</p>
                </div>
                <div className="inp">
                  <input
                    type="text"
                    id="documentNumber"
                    name="companyDocumentNumber"
                    placeholder="Enter Company Document Number"
                   
                    value={formData?.companyDocumentNumber}
                    onChange={handleInputChange}
                    className={
                      errors.companyDocumentNumber ? "error-input" : "input"
                    } // Apply error class
                    onBlur={handleFormFieldChange}
                  />
                  {errors.companyDocumentNumber && (
                    <div className="error">{errors.companyDocumentNumber}</div>
                  )}
                </div>
              </div> */}
            </>
          ) : (
            <div className="questions">
              <div className="que">
                {/* <p>10. What is your Company GSTIN? *</p> */}
                <p>
                  9. {userOnboardingQuestions.gstNumber}{" "}
                  {isRequireFields?.gstNumber == true ? (
                    <span className="asterisk-personal-info">*</span>
                  ) : (
                    ""
                  )}
                </p>
              </div>
              <div className="inp">
                <input
                  type="text"
                  id="gstNumber"
                  name="gstNumber"
                  placeholder="Enter GSTIN number"
                  maxLength={15}
                  // value={
                  //   isEditing.gstNumber
                  //     ? formData.gstNumber
                  //     : formData.gstNumber ||
                  //       userOnboardingDetails?.gstNumber ||
                  //       ""
                  // }
                  value={formData.gstNumber}
                  onChange={handleInputChange}
                  className={errors.gstNumber ? "error-input" : "input"} // Apply error class
                  onBlur={handleFormFieldChange}
                />
                {errors.gstNumber && (
                  <div className="error">{errors.gstNumber}</div>
                )}
              </div>
            </div>
          )}

          {formData.gstCheckbox !== "Yes" && (
            <div className="questions">
              <div className="que">
                <p>
                  {" "}
                  {formData.gstCheckbox === "No" ? `9.` : `10.`}{" "}
                  {userOnboardingQuestions.companyPanNumber}{" "}
                  {isRequireFields?.companyPanNumber == true ? (
                    <span className="asterisk-personal-info">*</span>
                  ) : (
                    ""
                  )}
                </p>
              </div>
              <div className="inp">
                <input
                  type="text"
                  id="companyPanNumber"
                  name="companyPanNumber"
                  placeholder="Enter PAN number"
                  maxLength={10}
                  value={formData?.companyPanNumber}
                  onChange={handleInputChange}
                  onBlur={handleFormFieldChange}
                  className={errors.companyPanNumber ? "error-input" : "input"}
                />
                {errors.companyPanNumber && (
                  <div className="error">{errors.companyPanNumber}</div>
                )}
              </div>
            </div>
          )}
          <div className="questions">
            <div className="que">
              {/* <p>12. Are you a retailer or a wholesaler? *</p> */}
              <p>
                {/* 12. {userOnboardingQuestions.retailerOrWholesaler}</p> */}
                {formData.gstCheckbox === "Yes"
                  ? `10.`
                  : formData.gstCheckbox === "No"
                    ? `10.`
                    : `11.`}{" "}
                {userOnboardingQuestions.retailerOrWholesaler}
                {isRequireFields?.retailerOrWholesaler == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="inp-btns">
              <button
                className={`yes-btn ${
                  formData.retailerOrWholesaler === "Retailer" ? "active" : ""
                } ${errors.retailerOrWholesaler ? "error-button" : ""}`}
                onClick={(e) =>
                  handleButtonClick(e, "retailerOrWholesaler", "Retailer")
                }
                onBlur={handleFormFieldChange}
              >
                Retailer
              </button>
              <button
                className={`no-btn ${
                  formData.retailerOrWholesaler === "Wholesaler" ? "active" : ""
                } ${errors.retailerOrWholesaler ? "error-button" : ""}`}
                onClick={(e) =>
                  handleButtonClick(e, "retailerOrWholesaler", "Wholesaler")
                }
                onBlur={handleFormFieldChange}
              >
                Wholesaler
              </button>
              {/* {errors.retailerOrWholesaler && (
                <div className="error">{errors.retailerOrWholesaler}</div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInfo;
